import { useIntl } from 'react-intl'
import { charactersToWords } from './validations'
import { denominatorDataId, numeratorDataId } from './utils'
import { calculateWordCount } from '../../lib/utils/strings'

interface WordCountProps {
  value: string
  maxChars: number
}

export const WordCount = (props: WordCountProps) => {
  const intl = useIntl()
  const { value, maxChars } = props

  const numWords = calculateWordCount(value)
  const maxWords = Math.floor(maxChars / charactersToWords)

  const wordCountTitle = intl.formatMessage(
    {
      id: 'inputs.wordCount.title',
      description: 'Inputs - Word Count - Title',
      defaultMessage: '{numWords} out of {maxWords} words',
    },
    { numWords, maxWords }
  )

  const wordCountCopy = intl.formatMessage(
    {
      id: 'inputs.wordCount.copy',
      description: 'Inputs - Word Count - Copy',
      defaultMessage: '{maxWords} words',
    },
    { maxWords }
  )

  return (
    <span aria-live="polite" role="status" aria-atomic="true" title={wordCountTitle}>
      <span aria-hidden="true">
        <span data-classname={numeratorDataId}>{numWords}</span>
        {
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
          '/'
        }
        <span data-classname={denominatorDataId}>{wordCountCopy}</span>
      </span>
    </span>
  )
}
